var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isLoading
        ? _c("loading-indicator")
        : _vm.requiresLogin
          ? _c("login-form", { on: { "logged-in": _vm.onLoggedIn } })
          : _vm.errorMsg
            ? _c(
                "form-container",
                { attrs: { size: "medium" } },
                [
                  _c("b-alert", { attrs: { variant: "danger", show: "" } }, [
                    _vm._v(_vm._s(_vm.errorMsg))
                  ])
                ],
                1
              )
            : _vm.hasUser || _vm.requiresInitialPassword
              ? _c(
                  "form-container",
                  { attrs: { size: "medium" } },
                  [
                    _vm.requiresInitialPassword
                      ? [
                          _c("h1", { staticClass: "page-title" }, [
                            _vm._v(_vm._s(_vm.$t("onboarding.signupTitle")))
                          ]),
                          _vm._v(" "),
                          _c("h4", { staticClass: "subtitle" }, [
                            _vm._v(
                              _vm._s(_vm.$t("onboarding.signupDescription"))
                            )
                          ])
                        ]
                      : [
                          _c("h1", { staticClass: "page-title" }, [
                            _vm._v(_vm._s(_vm.$t("onboarding.invitationTitle")))
                          ])
                        ],
                    _vm._v(" "),
                    _vm.requiresTermsOfServiceConsent
                      ? _c("div", { staticClass: "option" }, [
                          _c("p", { staticClass: "option__text" }, [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.$t("onboarding.terms")) +
                                "\n        "
                            ),
                            _c(
                              "a",
                              {
                                attrs: { href: _vm.$t("onboarding.termsUrl") }
                              },
                              [_vm._v(_vm._s(_vm.$t("onboarding.termsLink")))]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "option__agree" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  model: {
                                    value: _vm.didAcceptTermsOfService,
                                    callback: function($$v) {
                                      _vm.didAcceptTermsOfService = $$v
                                    },
                                    expression: "didAcceptTermsOfService"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "onboarding.acceptTermsOfService"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.requiresInitialPassword
                      ? _c(
                          "div",
                          { staticClass: "option" },
                          [
                            _c("p", { staticClass: "option__text" }, [
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    _vm.$t("onboarding.credentials", {
                                      username: _vm.username
                                    })
                                  ) +
                                  "\n      "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  horizontal: "",
                                  "label-cols": 3,
                                  "label-size": "sm",
                                  "label-class": "text-sm-right",
                                  label: _vm.$t("onboarding.password"),
                                  "label-for": "password1"
                                }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "password1",
                                    name: "password1",
                                    type: "password"
                                  },
                                  model: {
                                    value: _vm.password1,
                                    callback: function($$v) {
                                      _vm.password1 = $$v
                                    },
                                    expression: "password1"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.password1 && !_vm.isPassword1Valid
                              ? _c(
                                  "b-alert",
                                  { attrs: { variant: "info", show: "" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("onboarding.enterPasswordMsg")
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isPassword1Valid
                              ? _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      horizontal: "",
                                      "label-cols": 3,
                                      "label-size": "sm",
                                      "label-class": "text-sm-right",
                                      label: _vm.$t(
                                        "onboarding.passwordRepeated"
                                      ),
                                      "label-for": "password2"
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "password2",
                                        name: "password2",
                                        type: "password"
                                      },
                                      model: {
                                        value: _vm.password2,
                                        callback: function($$v) {
                                          _vm.password2 = $$v
                                        },
                                        expression: "password2"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isPassword1Valid && !_vm.passwordsMatch
                              ? _c(
                                  "b-alert",
                                  { attrs: { variant: "info", show: "" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("onboarding.repeatPasswordMsg")
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isPassword1Valid && _vm.passwordsMatch
                              ? _c(
                                  "b-alert",
                                  { attrs: { variant: "success", show: "" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("onboarding.passwordsMatchMsg")
                                      )
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.requiresInvitationConsent
                      ? _c("div", { staticClass: "option" }, [
                          _c("p", { staticClass: "option__text" }, [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm.$t("onboarding.invitation", {
                                    organizationName: _vm.organizationName
                                  })
                                ) +
                                "\n      "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "option__agree" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  model: {
                                    value: _vm.didAcceptInvitation,
                                    callback: function($$v) {
                                      _vm.didAcceptInvitation = $$v
                                    },
                                    expression: "didAcceptInvitation"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("onboarding.acceptInvitation")
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "buttons" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              disabled: !_vm.isCommitButtonEnabled,
                              variant: "primary"
                            },
                            on: { click: _vm.commit }
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.$t("onboarding.commit")) +
                                "\n      "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  2
                )
              : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-093c1f17", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-093c1f17","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OnboardingScreen.vue
// module id = null
// module chunks = 